<template>
  <Modal class="my-modal" v-model="visible" title="预览" :mask-closable="false" width="460px" :footer-hide="true">
    <div class="content">
      <div class="userInformation">
        <div class="headImage">
          <img :src="userList.headImage">
          <span>{{ userList.nickName }}</span>
        </div>
        <div>{{ filter.filterTime(contentList.createTime, 'YYYY-MM-DD HH:mm') || filter.filterTime(new Date(), 'YYYY-MM-DD HH:mm') }}</div>
      </div>
      <div class="tagList">
        <span v-for="(item, index) in tags" :key="index" class="tags">{{ item }}</span>
      </div>
      <div class="copywriting" v-html="contentList.copywriting"></div>
      <div v-if="contentList.type == '6' && contentList.linkContent.length > 0">
        <div class="momentsList">
          <img :src="item" :preview="_uid" class="momentsPicture" v-for="(item, index) in contentList.linkContent" :key="index" />
        </div>
      </div>
      <div v-if="contentList.type == '7' && contentList.linkContent.length > 0">
        <div class="momentsList">
          <video v-if="contentList.linkContent.length > 0" controls="controls" width="400" :src="contentList.linkContent"
            :poster="contentList.videoCover ? contentList.videoCover : ''"></video>
        </div>
      </div>
      <div class="articleBox" v-if="contentList.type == '8' && articleList.length > 0" @click="clickAr">
        <div>
          <span class="articleTitle">{{ articleList[0].title }}</span>
          <span class="useTime">{{ filter.filterTime(articleList[0].useTime, 'YYYY-MM-DD HH:mm') }}</span>
        </div>
        <img :src="articleList[0].coverImg" />
      </div>
    </div>
  </Modal>
</template>

<script>
import filter from "@/api/filter";
export default {
  props: {
    articleList: {
      default(){
        return []
      } 
    }
  },
  data() {
    return {
      filter,
      visible: false,
      userListArr: [],
      userList: [],
      tags: [],
      contentList: [],
    }
  },
  methods: {
    clickAr() {
      window.open(this.articleList[0].url, "_blank")
    },
    open(item) {
      this.contentList = item
      if(item.copywriting.indexOf('\n')!=-1){
        this.contentList.copywriting=this.contentList.copywriting.replace(/\n/g,'<br>')
      }
      if (item.tags) {
        this.tags = item.tags
      } else {
        this.tags = []
      }
      this.visible = true
      this.getUserList(item)
      this.$previewRefresh();
    },
    // 用户
    getUserList(item) {
      this.$http({
        url: "/buz/friendsCircleUser/querySelectList",
        type: "post",
        data: {},
      }).then((res) => {
        this.userListArr = res.data;
        this.userListArr.forEach((arr) => {
          if (arr.id == item.userId) {
            this.userList = arr
          }
        })
      }).catch((err) => {
        console.log(err)
      });
    },
  }

}
</script>

<style lang="scss" scoped>
/deep/ .ivu-modal-body {
  padding: 0 !important;
}

.content {
  padding: 20px;

  .userInformation {
    width: 100%;

    display: flex;
    justify-content: space-between;
    align-items: center;

    .headImage {
      display: flex;
      align-items: center;

      img {
        width: 41px;
        height: 41px;
        border-radius: 50%;
        margin-right: 10px;
      }
    }
  }

  .tagList {
    margin: 10px 0;

    .tags {
      background: #ECF1FA;
      width: 76px;
      height: 24px;
      color: #2E4F96;
      padding: 3px 8px;

      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }

  .momentsList {
    width: 100%;
    display: flex;
    flex-wrap: wrap;

    .momentsPicture {
      max-width: 100px;
      max-height: 140px;
      object-fit: cover;
      margin-right: 20px;
      margin-top:10px;
    }
  }

}

.articleBox {
  width: 100%;
  height: 98px;
  background: #F5F7F9;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;

  img {
    max-width: 110px;
    max-height: 68px;
    object-fit: cover;
  }

  .articleTitle {
    display: -webkit-box;
    width: 280px;
    height: 36px;
    font-size: 13px;
    font-family: PingFang SC;
    font-weight: 400;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    line-height: 18px;
    color: #515C6F;
  }

  .useTime {
    width: 61px;
    height: 14px;
    font-size: 12px;
    font-family: Arial;
    font-weight: 400;
    line-height: 14px;
    color: #727C8E;
  }
}
</style>